import React from 'react';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

export const compressions = {
  low: {
    meshMe: {
      key: 'meshMe',
      categoryTagId: 7961,
      carousel: {
        desktop: [
          'compression_guide_mesh_me_photo_carousel_1d',
          'compression_guide_mesh_me_photo_carousel_2d',
          'compression_guide_mesh_me_photo_carousel_3d',
          'compression_guide_mesh_me_photo_carousel_4d',
        ],
        mobile: [
          'compression_guide_mesh_me_photo_carousel_1m',
          'compression_guide_mesh_me_photo_carousel_2m',
          'compression_guide_mesh_me_photo_carousel_3m',
          'compression_guide_mesh_me_photo_carousel_4m',
        ],
      },
      difference: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.mesh_me_different_header"
            defaultMessage="What makes mesh different"
          />
        ),
      },
      differenceParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.mesh_me_different_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      heroContent: {
        fabric: {
          desktop: 'compression_guide_overlay_mesh_me_fabric_card_d',
          mobile: 'compression_guide_overlay_mesh_me_fabric_card_m',
        },
        text: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_hero "
              defaultMessage="Mesh Me"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_materials"
              defaultMessage="74% Polyester, 26% Cotton"
            />
          ),
        },
        info: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_paragraph"
              defaultMessage="&nbsp;"
            />
          ),
        },
      },
      imageSection: {
        mobile: 'compression_guide_overlay_mesh_me_image_m',
        desktop: 'compression_guide_overlay_mesh_me_image_d',
      },
      icons: [
        {
          asset: 'compression_guide_mesh_me_feature_icon_1',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_1"
              defaultMessage="Breathable"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_2',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_2"
              defaultMessage="No Roll Engineering"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_3',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_3"
              defaultMessage="Silver Seam Technology"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_4',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_4"
              defaultMessage="Sustainably Designed"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_5',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_5"
              defaultMessage="Zoned Support Panels"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_6',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_6"
              defaultMessage="No Show"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_7',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_7"
              defaultMessage="Moisture Wicking"
            />
          ),
        },
        {
          asset: 'compression_guide_mesh_me_feature_icon_8',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.mesh_me_feature_copy_8"
              defaultMessage="Low Compression"
            />
          ),
        },
      ],
      loveItParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.mesh_me_love_it_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      quote: {
        mobile: 'compression_guide_overlay_mesh_me_Lizzo_quote_m',
        desktop: 'compression_guide_overlay_mesh_me_Lizzo_quote_d',
      },
      shop: {
        link: '/shop/mesh-me',
        message: (
          <FormattedMessage
            id="compression_guide_overlay.shop_mesh_me"
            defaultMessage="Shop mesh me"
          />
        ),
      },
      fabricCard: {
        asset: {
          mobile: 'Compression_guide_Mesh_Me_fabric_card_m',
          desktop: 'Compression_guide_Mesh_Me_fabric_card_d',
        },
        header: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_header_mesh_me"
              defaultMessage="Mesh Me"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_materials_mesh_me"
              defaultMessage="74% Polyester, 26% Cotton"
            />
          ),
        },
        paragraph: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_paragraph_mesh_me"
              defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo."
            />
          ),
        },
        buttons: {
          learnMore: {
            message: (
              <FormattedMessage
                id="compression_guide.learn_more"
                defaultMessage="Learn More"
              />
            ),
            variant: 'primary',
          },
          shop: {
            path: '/shop/mesh-me',
            message: (
              <FormattedMessage
                id="compression_guide.shop_mesh"
                defaultMessage="Shop Mesh"
              />
            ),
            variant: 'secondary',
          },
        },
      },
    },
  },
  medium: {
    headliner: {
      key: 'headliner',
      categoryTagId: 7959,
      carousel: {
        desktop: [
          'compression_guide_headliner_photo_carousel_1',
          'compression_guide_headliner_photo_carousel_2',
          'compression_guide_headliner_photo_carousel_3',
          'compression_guide_headliner_photo_carousel_4',
        ],
        mobile: [
          'compression_guide_headliner_photo_carousel_1',
          'compression_guide_headliner_photo_carousel_2',
          'compression_guide_headliner_photo_carousel_3',
          'compression_guide_headliner_photo_carousel_4',
        ],
      },
      difference: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.headliner_different_header"
            defaultMessage="What makes headliner different"
          />
        ),
      },
      differenceParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.headliner_different_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      heroContent: {
        fabric: {
          desktop: 'compression_guide_overlay_headliner_fabric_card',
          mobile: 'compression_guide_overlay_headliner_fabric_card',
        },
        text: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.headliner_hero"
              defaultMessage="Headliner"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.headliner_materials"
              defaultMessage="74% Polyester, 26% Cotton"
            />
          ),
        },
        info: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.headliner_paragraph"
              defaultMessage="&nbsp;"
            />
          ),
        },
      },
      imageSection: {
        mobile: 'compression_guide_overlay_headliner_image',
        desktop: 'compression_guide_overlay_headliner_image',
      },
      icons: [
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_1',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_1"
              defaultMessage="Breathable"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_2',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_2"
              defaultMessage="No Roll Engineering"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_3',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_3"
              defaultMessage="Silver Seam Technology"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_4',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_4"
              defaultMessage="Sustainably Designed"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_5',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_5"
              defaultMessage="Zoned Support Panels"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_6',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_6"
              defaultMessage="No Show"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_7',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_7"
              defaultMessage="Moisture Wicking"
            />
          ),
        },
        {
          asset: 'Compression_Guide_Seamless_Feature_Icon_8',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_8"
              defaultMessage="Low Compression"
            />
          ),
        },
      ],
      loveItParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.headliner_love_it_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      quote: {
        mobile: 'compression_guide_overlay_seamless_Lizzo_quote_m',
        desktop: 'compression_guide_overlay_seamless_Lizzo_quote_d',
      },
      shop: {
        link: '/shop/headliner',
        message: (
          <FormattedMessage
            id="compression_guide_overlay.shop_headliner"
            defaultMessage="Shop Headliner"
          />
        ),
      },
      fabricCard: {
        asset: {
          mobile: 'compression_guide_headliner_fabric_card',
          desktop: 'compression_guide_headliner_fabric_card',
        },
        header: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_header_headliner"
              defaultMessage="Headliner"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_materials_headliner"
              defaultMessage="70% Recycled Polester, 30% Spandex
              "
            />
          ),
        },
        paragraph: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_paragraph_headliner"
              defaultMessage="Don't settle for opening act; be the headliner! A fabric that is fit for center stage."
            />
          ),
        },
        buttons: {
          learnMore: {
            message: (
              <FormattedMessage
                id="compression_guide.learn_more"
                defaultMessage="Learn More"
              />
            ),
            variant: 'primary',
          },
          shop: {
            path: '/shop/headliner',
            message: (
              <FormattedMessage
                id="compression_guide.shop_headliner"
                defaultMessage="Shop Headliner"
              />
            ),
            variant: 'secondary',
          },
        },
      },
    },
    seamless: {
      key: 'seamless',
      categoryTagId: 7959,
      carousel: {
        desktop: [
          'compression_guide_seamless_photo_carousel_1d',
          'compression_guide_seamless_photo_carousel_2d',
          'compression_guide_seamless_photo_carousel_3d',
          'compression_guide_seamless_photo_carousel_4d',
        ],
        mobile: [
          'compression_guide_seamless_photo_carousel_1m',
          'compression_guide_seamless_photo_carousel_2m',
          'compression_guide_seamless_photo_carousel_3m',
          'compression_guide_seamless_photo_carousel_4m',
        ],
      },
      difference: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.seamless_different_header"
            defaultMessage="What makes seamless different"
          />
        ),
      },
      differenceParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.seamless_different_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      heroContent: {
        fabric: {
          desktop: 'compression_guide_overlay_seamless_fabric_card_d',
          mobile: 'compression_guide_overlay_seamless_fabric_card_m',
        },
        text: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_hero "
              defaultMessage="Nearly Naked Seamless"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_materials"
              defaultMessage="74% Polyester, 26% Cotton"
            />
          ),
        },
        info: {
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_paragraph"
              defaultMessage="&nbsp;"
            />
          ),
        },
      },
      imageSection: {
        mobile: 'compression_guide_overlay_seamless_image_m',
        desktop: 'compression_guide_overlay_seamless_image_d',
      },
      icons: [
        {
          asset: 'compression_guide_seamless_feature_icon_1',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_1"
              defaultMessage="Breathable"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_2',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_2"
              defaultMessage="No Roll Engineering"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_3',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_3"
              defaultMessage="Silver Seam Technology"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_4',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_4"
              defaultMessage="Sustainably Designed"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_5',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_5"
              defaultMessage="Zoned Support Panels"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_6',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_6"
              defaultMessage="No Show"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_7',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_7"
              defaultMessage="Moisture Wicking"
            />
          ),
        },
        {
          asset: 'compression_guide_seamless_feature_icon_8',
          message: (
            <FormattedMessage
              id="compression_guide_overlay.seamless_feature_copy_8"
              defaultMessage="Low Compression"
            />
          ),
        },
      ],
      loveItParagraph: {
        message: (
          <FormattedMessage
            id="compression_guide_overlay.seamless_love_it_paragraph"
            defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo ut dictumst elementum nulla aenean tortor augue."
          />
        ),
      },
      quote: {
        mobile: 'compression_guide_overlay_seamless_Lizzo_quote_m',
        desktop: 'compression_guide_overlay_seamless_Lizzo_quote_d',
      },
      shop: {
        link: '/shop/nearly-naked',
        message: (
          <FormattedMessage
            id="compression_guide_overlay.shop_seamless"
            defaultMessage="Shop seamless"
          />
        ),
      },
      fabricCard: {
        asset: {
          mobile: 'Compression_guide_Seamless_fabric_card_m',
          desktop: 'Compression_guide_Seamless_fabric_card_d',
        },
        header: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_header_seamless"
              defaultMessage="Nearly Naked Seamless"
            />
          ),
        },
        materials: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_materials_seamless"
              defaultMessage="74% Polyester, 26% Cotton"
            />
          ),
        },
        paragraph: {
          message: (
            <FormattedMessage
              id="compression_guide.fabric_card_paragraph_seamless"
              defaultMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis tortor enim, at non risus nisi, cursus ac. Euismod leo."
            />
          ),
        },
        buttons: {
          learnMore: {
            message: (
              <FormattedMessage
                id="compression_guide.learn_more"
                defaultMessage="Learn More"
              />
            ),
            variant: 'primary',
          },
          shop: {
            path: '/shop/nearly-naked',
            message: (
              <FormattedMessage
                id="compression_guide.shop_seamless"
                defaultMessage="Shop Seamless"
              />
            ),
            variant: 'secondary',
          },
        },
      },
    },
  },
  high: {
    comingSoon: true,
    asset: {
      desktop: 'Compression_guide_coming_soon_tease_d',
      mobile: 'Compression_guide_coming_soon_tease_m',
    },
  },
};
